import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { UsersProvider } from "./context/UsersContext";
import { FinanzasProvider } from "./context/FinanzasContext";
import { NotasProvider } from "./context/NotasContext";
import { SalonesProvider } from "./context/SalonesContext";
import { EventosProvider } from "./context/EventosContext";
import { BoletinProvider } from "./context/BoletinContext";
import { AsignaturasProvider } from "./context/AsignaturasContext";
import Notification from "./components/Notification";
import { useAuth } from "./context/AuthContext";

// Páginas
import LoginForm from "./pages/LoginForm";
import PrivateRoute from "./utils/PrivateRoute";
import PublicRoute from "./utils/PublicRoutes";
import Dashboard from "./pages/Dashboard";
import StudentsPage from "./pages/StudentsPage";
import TeachersPage from "./pages/TeachersPage";
import TeacherForm from "./components/FromUsers/TeacherForm";
import StudentForm from "./components/FromUsers/StudentForm";
import Finanzas from "./pages/Finanzas";
import PagoForm from "./components/Finanzas/PagosForm";
import Detalles from "./pages/DetallesPerfil";
import Eventos from "./pages/Eventos";
import NotasPage from "./pages/NotasPage";
import HorariosPage from "./pages/HorariosPage";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import ResetPassword from "./pages/ForgotPassword/ResetPassword";
import VerificationOTP from "./pages/ForgotPassword/VerifyOTP";
import Boletin from "./pages/Boletin";
import BoletinFinalPage from "./pages/BoletinFinalPage";
import IndicadoresPage from "./pages/Indicadores";
import AsignaturasPage from "./pages/AsignaturasPage";
import { IndicadoresProvider } from "./context/IndicadoresContext";


function App() {
  const { notification, clearNotification } = useAuth();

  // Encapsular todos los providers en un solo bloque
  const Providers = ({ children }) => (
    <UsersProvider>
      <FinanzasProvider>
        <NotasProvider>
          <AsignaturasProvider>
            <BoletinProvider>
              <IndicadoresProvider>
                <SalonesProvider>
                  <EventosProvider>{children}</EventosProvider>
                </SalonesProvider>
              </IndicadoresProvider>
            </BoletinProvider>
          </AsignaturasProvider>
        </NotasProvider>
      </FinanzasProvider>
    </UsersProvider>
  );

  return (
    <Providers>
      {notification && (
        <Notification
          type={notification.type}
          message={notification.message}
          onClose={clearNotification}
        />
      )}
      <Routes>
        {/* Rutas públicas */}
        <Route element={<PublicRoute />}>
          <Route path="/login" element={<LoginForm />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/verify-otp" element={<VerificationOTP />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Route>

        {/* Rutas privadas para administradores (rol_id === 1) */}
        <Route element={<PrivateRoute allowedRoles={[1]} />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/notas" element={<NotasPage />} />
          <Route path="/asignaturas" element={<AsignaturasPage />} />
          <Route path="/boletin" element={<Boletin />} />
          <Route path="/boletin-final" element={<BoletinFinalPage />} />
          <Route path="/detalles" element={<Detalles />} />
          <Route path="/eventos" element={<Eventos />} />
          <Route path="/horarios" element={<HorariosPage />} />
          <Route path="/estudiantes" element={<StudentsPage />} />
          <Route path="/profesores" element={<TeachersPage />} />
          <Route path="/profesores/nuevo" element={<TeacherForm />} />
          <Route path="/estudiantes/nuevo" element={<StudentForm />} />
          <Route path="/profesores/editar/:id" element={<TeacherForm />} />
          <Route path="/estudiantes/editar/:id" element={<StudentForm />} />
          <Route path="/finanzas" element={<Finanzas />} />
          <Route path="/finanzas/nuevo" element={<PagoForm />} />
          <Route path="/finanzas/editar/:id" element={<PagoForm />} />
        </Route>

        {/* Rutas privadas para profesores (rol_id === 2) */}
        <Route element={<PrivateRoute allowedRoles={[2]} />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/notas" element={<NotasPage />} />
          <Route path="/indicadores" element={<IndicadoresPage />} />
          <Route path="/boletin" element={<Boletin />} />
          <Route path="/boletin-final" element={<BoletinFinalPage />} />
          <Route path="/detalles" element={<Detalles />} />
          <Route path="/eventos" element={<Eventos />} />          
          <Route path="/horarios" element={<HorariosPage />} />
          <Route path="/estudiantes" element={<StudentsPage />} />
        </Route>

        {/* Rutas privadas para estudiantes (rol_id === 3) */}
        <Route element={<PrivateRoute allowedRoles={[3]} />}>
          <Route path="/detalles" element={<Detalles />} />
          <Route path="/notas" element={<NotasPage />} />
          <Route path="/boletin" element={<Boletin />} />
          <Route path="/boletin-final" element={<BoletinFinalPage />} />
          <Route path="/eventos" element={<Eventos />} />
          <Route path="/horarios" element={<HorariosPage />} />
          <Route path="*" element={<Navigate to="/detalles" />} />
        </Route>

        {/* Ruta por defecto */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Providers>
  );
}

export default App;
